
export default {
  // 判断是否是微信浏览器
  isWechat() {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  },

  isIOS() {
    var ua = window.navigator.userAgent
    return /iPhone|iPad|iPod/i.test(ua)
  },

  isAndroid() {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('android') > -1 || ua.indexOf('linux') > -1) {
      return true
    } else {
      return false
    }
  },

  /**
   * 删除url中指定的参数
   * @param {} name 参数名
   */
  removeUrlParam(originUrl, name) {
    var arr = originUrl.split('?')
    if (arr.length > 1) {
      var baseUrl = arr[0]
      var query = arr[1]
      if (query.indexOf(name) > -1) {
        var obj = {}
        var array = query.split('&')
        for (var i = 0; i < array.length; i++) {
          array[i] = array[i].split('=')
          obj[array[i][0]] = array[i][1]
        }
        delete obj[name]
        var url = ''
        if (JSON.stringify(obj) === '{}') {
          url = baseUrl
        } else {
          url = baseUrl + '?' + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
        }
        return url
      } else {
        return originUrl
      }
    } else {
      return originUrl
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/util.js